/* unplugin-vue-components disabled */import script from "./401.vue?vue&type=script&setup=true&lang=js"
export * from "./401.vue?vue&type=script&setup=true&lang=js"

import "./401.vue?vue&type=style&index=0&id=3489cd3c&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3489cd3c"]])

export default __exports__